import { render, staticRenderFns } from "./user_avatar_list.vue.js?vue&type=template&id=08590d33!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_avatar_list.vue?vue&type=template&id=08590d33"
import script from "./user_avatar_list.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_avatar_list.vue?vue&type=script&lang=js"
export * from "./user_avatar_list.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_avatar_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports